export function isObject(
  maybeObj: unknown
): maybeObj is Record<string, unknown> {
  return typeof maybeObj === "object" && maybeObj !== null;
}
